// extracted by mini-css-extract-plugin
export default {"loader":"muNjcFTZiquJuts02oP_"};